module.exports = __webpack_public_path__ + "web_static/media/header_animation.1376e6a1.mp4";